<template>
	<div>
		<section class="b360-grid-row">
			<div class="b360-col-4 btn-fixed-bottom">
				<button
					class="b360-btn b360-btn--workspace-primary"
					type="button"
					@click="navigateBack"
				>
					&#60; Go Back
				</button>
			</div>
		</section>

		<section class="error-page">
			<font-awesome-icon :icon="['fal', 'exclamation-triangle']" />
			<p>
				Something went wrong loading this page. Please check back later or
				contact your AE.
			</p>
		</section>
	</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	name: 'BbPricingError',
	methods: {
		...mapActions(['updatePricingFields']),

		navigateBack() {
			this.updatePricingFields({
				fieldName: 'activeForm',
				value: 1,
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.error-page {
	height: calc(
		100vh - 181px
	); /* This centers the content and accounts for the heights of the Header, parent Div Margin and Back section above. */
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	svg {
		@include rem(font-size, 44px);
		color: $brand-teal;
	}

	p {
		text-align: center;
	}
}
</style>
